"use client";

import React from "react";
import { ArrowUpRight, ChevronRight, Mail, MapPin, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i} className="h-5 w-24 bg-muted/50 animate-pulse rounded-md" />)}
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-secondary transition-colors inline-flex items-center gap-1 group text-sm">
            <ChevronRight className="size-3 opacity-0 -ml-4 group-hover:opacity-100 group-hover:ml-0 transition-all text-secondary" />
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function PatientResources() {
  const services = ["Sleep Apnea Diagnosis", "Oral Appliance Therapy", "CPAP Alternative Solutions", "Patient Consultations", "Referral Coordination"];
  const getServiceLink = (service: string) => {
    if (service.includes("Oral") || service.includes("CPAP")) return "/OralAppliancesPage";
    if (service.includes("Diagnosis")) return "/SleepApneaPage";
    if (service.includes("Referral")) return "/PhysiciansPage";
    return "/HomePage";
  };
  return <section id="patient-resources" className="dark bg-background text-foreground pt-20 pb-8 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-16">
          {}
          <div className="flex flex-col gap-6">
            <Link to="/HomePage" className="inline-block w-fit">
              <img src="https://asleepdentist.com/wp-content/uploads/2026/04/Mask-group-scaled.png" className="h-12 w-auto object-contain" alt="Website Logo" />
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed max-w-xs">
              Providing empathetic, patient-focused care. We specialize in modern oral appliance therapy as a comfortable, effective alternative to traditional CPAP machines.
            </p>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-lg font-semibold tracking-tight">Quick Links</h3>
            <MenuProvider menu_id="39">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-lg font-semibold tracking-tight">Our Services</h3>
            <ul className="space-y-3">
              {services.map((service, i) => <li key={i} data-index={i}>
                  <Link to={getServiceLink(service)} className="text-muted-foreground hover:text-secondary transition-colors inline-flex items-center gap-1 group text-sm">
                    <ChevronRight className="size-3 opacity-0 -ml-4 group-hover:opacity-100 group-hover:ml-0 transition-all text-secondary" />
                    {service}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-lg font-semibold tracking-tight">Contact Us</h3>
            <ul className="space-y-4">
              <li>
                <Link to="tel:(Your Phone Number)" className="flex items-start gap-3 text-muted-foreground hover:text-secondary transition-colors group">
                  <div className="bg-muted/20 p-2 rounded-md group-hover:bg-secondary/20 transition-colors shrink-0">
                    <Phone className="size-4 text-secondary" />
                  </div>
                  <span className="text-sm mt-1">(310) 858-7373</span>
                </Link>
              </li>
              <li>
                <Link to="mailto:info@asleepdentist.com" className="flex items-start gap-3 text-muted-foreground hover:text-secondary transition-colors group">
                  <div className="bg-muted/20 p-2 rounded-md group-hover:bg-secondary/20 transition-colors shrink-0">
                    <Mail className="size-4 text-secondary" />
                  </div>
                  <span className="text-sm mt-1">support@restoredentalcenters.com</span>
                </Link>
              </li>
              <li>
                <div className="flex items-start gap-3 text-muted-foreground group">
                  <div className="bg-muted/20 p-2 rounded-md group-hover:bg-secondary/20 transition-colors shrink-0">
                    <MapPin className="size-4 text-secondary" />
                  </div>
                  <div className="flex flex-col gap-1.5 mt-1">
                    <span className="text-sm">2002 South Hoover Street Los Angeles, CA 90007</span>
                   
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {}
        <Separator className="bg-secondary/20 mb-8" />
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-muted-foreground">
          <p>© {new Date().getFullYear()} A Sleep Dentist. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <Link to="#" className="hover:text-secondary transition-colors">
              Privacy Policy
            </Link>
            <Link to="#" className="hover:text-secondary transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </section>;
}